import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/a1/lbs'

const memberList = async (curPage, result) => {
    let finalData = {
        items: {},
        totalPage: 0
    }
    const options = {
        method: 'GET',
        url: apiUrlEx + '/member',
        // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
            page: curPage
        }
    }

    await axios(options)
        .then((response) => {
            if (response.data.code === 100) {
                finalData.items = response.data.data
                finalData.totalPage = response.data.paginate.totalPage
                result(finalData)
            } else {
                result(null)
            }
        })

}

const termList = async (curPage, result) => {
    let finalData = {
        items: {},
        totalPage: 0
    }
    const options = {
        method: 'GET',
        url: apiUrlEx + '/term',
        // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
            page: curPage
        }
    }

    await axios(options)
        .then((response) => {
            if (response.data.code === 100) {
                finalData.items = response.data.data
                finalData.totalPage = response.data.paginate.totalPage
                result(finalData)
            } else {
                result(null)
            }
        })

}

const logList = async (curPage, result) => {
    let finalData = {
        items: {},
        totalPage: 0
    }
    const options = {
        method: 'GET',
        url: apiUrlEx + '/log',
        // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
            page: curPage
        }
    }

    await axios(options)
        .then((response) => {
            if (response.data.code === 100) {
                finalData.items = response.data.data
                finalData.totalPage = response.data.paginate.totalPage
                result(finalData)
            } else {
                result(null)
            }
        })

}

export default {
    memberList,
    termList,
    logList
}
